import { Component } from '@angular/core';
import { InvitationApiService } from '@app/services/invitation-api.service';
import { InvitationInterface } from '@app/interface/invitation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { TypeOptions } from '@app/interface/type-options';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { LayoutService } from '@app/layout/layout.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { RouterModule } from '@angular/router';
import { ChangeDetectionStrategy, signal } from '@angular/core';
import { EventEmitter, OnChanges, OnInit, Output } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { isNullOrUndefined } from '@app/shared/utils';
import { MatExpansionModule } from '@angular/material/expansion';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms'; // Add this import
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'izy-invitation',
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatListModule,
    MatChipsModule,
  ],
  standalone: true,
  templateUrl: './invitation.component.html',
  styleUrl: './invitation.component.scss',
})
export class InvitationComponent implements OnInit {
  // invitationForm: FormGroup;
  // invitations: InvitationInterface[] = [];
  // isLoading = false;
  // generatedUrl: string = '';
  // baseUrl: string = window.location.origin; // Gets your app's base URL
  // email: string = 'prova@gmail.com';
  // loading: boolean = false;
  // message: string = '';
  // error: string = '';
  // constructor(
  //   private invitationService: InvitationApiService,
  //   private fb: FormBuilder,
  //   private snackBar: MatSnackBar
  // ) {
  //   this.invitationForm = this.fb.group({
  //     email: ['', [Validators.required, Validators.email]],
  //   });
  // }
  ngOnInit(): void {}
  // organization_id = 1;
  // loadInvitations(): void {
  //   this.isLoading = true;
  //   const subscription = this.invitationService
  //     .getOrganizationInvitations(this.organization_id, {})
  //     .subscribe({
  //       next: (response: any) => {
  //         this.invitations = response.results || response;
  //         this.isLoading = false;
  //       },
  //       error: (error: any) => {
  //         console.error('Error loading invitations:', error);
  //         this.isLoading = false;
  //         this.showSnackBar('Error loading invitations', 'error');
  //       },
  //     });
  // }
  // // createInvitation(): void {
  // //   if (this.invitationForm.valid) {
  // //     this.isLoading = true;
  // //     const invitationData: Partial<InvitationInterface> = {
  // //       email: this.invitationForm.get('email')?.value,
  // //     };
  // //     this.invitationService.sendInvitation(email, invitationData).subscribe({
  // //       next: (invitation: InvitationInterface) => {
  // //         this.generateInvitationUrl(invitation.uuid);
  // //         this.loadInvitations(); // Reload the list
  // //         this.invitationForm.reset();
  // //         this.showSnackBar('Invitation created successfully!', 'success');
  // //       },
  // //       error: (error) => {
  // //         console.error('Error creating invitation:', error);
  // //         this.isLoading = false;
  // //         this.showSnackBar('Error creating invitation', 'error');
  // //       },
  // //     });
  // //   }
  // // }
  // // Get organization invitations
  // // loadOrganizationInvitations() {
  // //   if (!this.organization_id) {
  // //     console.warn('Organization ID is not available');
  // //     return;
  // //   }
  // //   this.isLoading = true;
  // //   this.invitationService
  // //     .getOrganizationInvitations(this.organization_id)
  // //     .subscribe({
  // //       next: (invitationsResponse) => {
  // //         // Handle the recursive response structure
  // //         if (invitationsResponse && invitationsResponse.results) {
  // //           this.invitations = invitationsResponse.results;
  // //         } else if (Array.isArray(invitationsResponse)) {
  // //           this.invitations = invitationsResponse;
  // //         }
  // //         this.isLoading = false;
  // //         console.log('Organization invitations:', this.invitations);
  // //       },
  // //       error: (error) => {
  // //         console.error('Error loading invitations:', error);
  // //         this.isLoading = false;
  // //       },
  // //     });
  // // }
  // // Get status color for chips
  // getStatusColor(status: string): string {
  //   switch (status) {
  //     case 'PENDING':
  //       return 'primary';
  //     case 'ACCEPTED':
  //       return 'accent';
  //     case 'DECLINED':
  //       return 'warn';
  //     case 'EXPIRED':
  //       return 'warn';
  //     default:
  //       return 'primary';
  //   }
  // }
  // // Format date if available
  // formatDate(dateString: string): string {
  //   if (!dateString) return 'N/A';
  //   return new Date(dateString).toLocaleDateString();
  // }
  // // Refresh invitations
  // refreshInvitations() {
  //   this.loadOrganizationInvitations();
  // }
  // // -------------
  // sendInvitation() {
  //   console.log('email:', this.email);
  //   this.loading = true;
  //   this.message = '';
  //   this.error = '';
  //   this.invitationService.sendInvitation(1, this.email).subscribe({
  //     next: (response) => {
  //       this.message = `Invitation sent to ${response.email}`;
  //       this.email = '';
  //       this.loading = false;
  //     },
  //     error: (error) => {
  //       this.error = error.error?.error || 'Failed to send invitation';
  //       this.loading = false;
  //     },
  //   });
  // }
  // generateInvitationUrl(uuid: string): void {
  //   // Assuming your invitation acceptance endpoint is at /accept-invitation/{uuid}
  //   this.generatedUrl = `${this.baseUrl}/accept-invitation/${uuid}`;
  //   this.isLoading = false;
  // }
  // copyToClipboard(): void {
  //   if (this.generatedUrl) {
  //     navigator.clipboard
  //       .writeText(this.generatedUrl)
  //       .then(() => {
  //         this.showSnackBar('Invitation URL copied to clipboard!', 'success');
  //       })
  //       .catch((err) => {
  //         console.error('Failed to copy: ', err);
  //         this.showSnackBar('Failed to copy URL', 'error');
  //       });
  //   }
  // }
  // getInvitationUrl(uuid: string): string {
  //   return `${this.baseUrl}/accept-invitation/${uuid}`;
  // }
  // copyInvitationUrl(uuid: string): void {
  //   const url = this.getInvitationUrl(uuid);
  //   navigator.clipboard.writeText(url).then(() => {
  //     this.showSnackBar('Invitation URL copied to clipboard!', 'success');
  //   });
  // }
  // private showSnackBar(message: string, type: 'success' | 'error'): void {
  //   this.snackBar.open(message, 'Close', {
  //     duration: 3000,
  //     panelClass: [`snackbar-${type}`],
  //   });
  // }
  // getStatusBadgeClass(status: string): string {
  //   switch (status) {
  //     case 'PENDING':
  //       return 'status-pending';
  //     case 'ACCEPTED':
  //       return 'status-accepted';
  //     case 'DECLINED':
  //       return 'status-declined';
  //     case 'EXPIRED':
  //       return 'status-expired';
  //     default:
  //       return 'status-default';
  //   }
  // }
}
